module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div style="display:inline-block; float:left;	width: 90%;text-align: center;">\r\n    '+
((__t=(text))==null?'':__t)+
'\r\n</div>\r\n<div class="phx-hd-btn ui-menu-icons" style="float:right;width: 18px;margin:1.5px 2.5px 0 1.5px;padding:0;">\r\n    <ul style="position: fixed;z-index: 10;"></ul>\r\n    <button type="button" style="width: 18px;margin:1;padding:0"></button>\r\n</div>';
}
return __p;
};
